import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { DivisionsTableDefinitionZod } from '../tables';

type Arguments = {
    aggregateId: string;
};

export const schemaDivisionResolver_GetByAggregateId = DivisionsTableDefinitionZod.nullable();

export type SchemaDivisionResolver_GetByAggregateId = z.infer<typeof schemaDivisionResolver_GetByAggregateId>;

export type DivisionResolver_GetByAggregateId = Resolver<Arguments, SchemaDivisionResolver_GetByAggregateId>;
